export const aiUsageTestIds = {
  badge: 'ai-usage-badge',
  panel: 'ai-usage-slideover',
  overlay: 'ai-usage-overlay',
  closeButton: 'ai-usage-close-btn',
  total: 'ai-usage-total',
  progressFill: 'ai-usage-progress-fill',
  scopeButton: (scope: 'mine' | 'org') => `ai-usage-scope-${scope}` as const,
  agentRow: (id: string) => `ai-usage-agent-${id}` as const,
  upgradeButton: 'ai-usage-upgrade-button',
  upgradePendingBanner: 'ai-usage-upgrade-pending-banner',
} as const;
